import {useHistory} from "react-router-dom";
import React, {useState, useEffect} from 'react';

function IndexPage() {
    const history = useHistory();

    function handleBeginClick() {
        history.push("/instruction");
        return true;
    }
    useEffect(function() {
        setTimeout(function () {
            BX24.fitWindow();
        }, 500)
    }, []);


    return (
        <div className="IndexPage">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-4 offset-1">
                        <a href="https://www.severcode.ru" target="_blank">
                            <img src="/img/logo.svg" alt="SeverCode"/>
                        </a>

                        <div className="title">
                            <span>Приложение для импорта данных из RetailCRM</span>
                            в Битрикс24
                        </div>
                        <a href="#" className="button" onClick={handleBeginClick}>
                            Начать
                        </a>
                    </div>
                    <div className="col-7">
                        <img src="/img/splash1.svg" alt=""/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2 offset-10 text-right">
                        <div className="paging">
                            1 / 5
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default IndexPage;
